import React from 'react'
import styled from 'styled-components'
import { useLocation } from '../../../context/Location'

const PumHelpText = styled.p`
  color: ${({ theme }) => theme.colors.platinum80};
  font-size: 14px;
  line-height: 18px;
  text-align: center;
  margin-top: 2px;
  margin-bottom: 0;
`

type Props = {
  pum: number
  className?: string
}

export default ({ pum, className = '' }: Props) => {
  const { toCurrency } = useLocation()

  return (
    <PumHelpText className={className}>
      {toCurrency(pum)}
      <span> x lt</span>
    </PumHelpText>
  )
}
